import React from 'react'
import ReactDOM from 'react-dom/client'

import { AboutDetail } from '../pages/about'

import '../pages/about/style.less'

const rootEl = document.getElementById('root')
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl)
  root.render(
    <React.StrictMode>
      <AboutDetail />
    </React.StrictMode>
  )
}
